module.exports = __webpack_public_path__ + "static/media/sku715005494.36f69746.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/sku715005494.png
// module id = 598
// module chunks = 0